import React, { useState, useEffect } from 'react';
import { Button, Form, Col, Row, InputGroup, Modal, Card } from 'react-bootstrap';
import { Header, Divider, Segment, Image, Dimmer, Loader } from 'semantic-ui-react'
import { store } from 'xijs';
import { message, Typography } from 'antd';
import GlobalAPI from '../resource/api';

function simulateNetworkRequest() {
	return new Promise((resolve) => setTimeout(resolve, 100000));
}

export default function ESP() {

	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1,                   //月份
			"d+": this.getDate(),                        //日
			"h+": this.getHours(),                       //小时
			"m+": this.getMinutes(),                     //分
			"s+": this.getSeconds(),                     //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds()                  //毫秒
		};

		//  获取年份 
		// ①
		if (/(y+)/i.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (var k in o) {
			// ②
			if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	}

	const [type, setType] = useState("seq");
	const [sequence, setSequence] = useState();
	const [file1, setFile1] = useState();
	const [file2, setFile2] = useState();
	const [file3, setFile3] = useState();
	const [description, setDescription] = useState();
	// const [disable, setDisable] = useState(true);
	const [isLoading, setIsLoading] = useState(false);


	function Jump2Results() {
		setTimeout(
			() => {
				window.location.reload();
			},
			1000
		);
	}


	function handleSubmit() {
		setIsLoading(true);


		if (type === "seq") {
			let current = {
				type: type,
				sequence: sequence,
				// file1: file1,
				file2: file2,
				file3: file3,
				description: description
			};
			postRequest(current);
		} else {
			let current2 = {
				type: type,
				// sequence: sequence,
				file1: file1,
				file2: file2,
				file3: file3,
				description: description
			};
			postRequest(current2);
		}
		

	}

	async function postRequest(props) {
		try {
			const formData = new FormData();

			if (props.type === "seq") {
				if (!props.sequence) {
					message.error("请输入序列");
					setIsLoading(false);
					return;
				}
				formData.append("fasta", props.sequence);
			} else {
				if (props.file1) {
					formData.append("fasta_file", props.file1);
				}
			}

			if (props.description) {
				formData.append("function_description", props.description);
			}

			if (props.file2) {
				formData.append("substrate_file", props.file2);
			}

			if (props.file3) {
				formData.append("product_file", props.file3);
			}

			if (!props.sequence && !props.file1) {
				message.error("请提供序列或上传序列文件");
				setIsLoading(false);
				return;
			}

			const response = await fetch(`${GlobalAPI}/api/p450/submit`, {
				method: 'POST',
				body: formData
			});

			const result = await response.json();

			if (result.message) {
				message.success("提交成功。");
				Jump2Results();
			}
		} catch (error) {
			console.error("提交失败:", error);
			message.error("提交失败，请重试");
		} finally {
			setIsLoading(false);
		}
	};



	return (
		<div style={{
			background: "#FFFFFF"

		}}>

			<Row>
				<Col>
				</Col>
				<Col md={10}>

					<div style={{

						height: "50px"
					}}>
					</div>
					<div>


						<Card>
							<Card.Header>
								<Header style={{ color: "#6495ED", textAlign: "center" }} >P450 Enzyme Submission</Header>
							</Card.Header>
							<Card.Body >

								<Form>
									<Form.Group as={Row} >
										<Form.Label column sm="3" className="top3">
											Input Type
										</Form.Label>
										<Col sm="8">
											<Form.Control as="select" value={type} onChange={(e) => setType(e.target.value)} >
												<option value="seq">Sequence</option>
												<option value="fasta">File</option>
											</Form.Control>

										</Col>

									</Form.Group>

									{/* <Divider /> */}

									{
										type === "seq"
											?
											<Form.Group as={Row} >
												<Form.Label column sm="3" className="top3">
													Sequence
												</Form.Label>
												<Col sm="8">
													<Form.Control type="text" placeholder="e.g.: >name\nMSEKFKL" onChange={(e) => setSequence(e.target.value)} />

												</Col>

											</Form.Group>
											:
											null
									}

									{
										type === "fasta"
											?
											<Form.Group as={Row} >
												<Form.Label column sm="3" className="top3">
													Sequence
												</Form.Label>
												<Col sm="8">

													<Form.File id="exampleFormControlFile1" onChange={(e) => setFile1(e.target.files[0])} accept=".fa,.fasta,.txt" />
												</Col>

											</Form.Group>
											:
											null
									}

									<Form.Group as={Row} >
										<Form.Label column sm="3" className="top3">
											Description
										</Form.Label>
										<Col sm="8">

											<Form.Control type="text" placeholder="optional (e.g.: P450-1)" onChange={(e) => setDescription(e.target.value)} />
										</Col>

									</Form.Group>

									{/* <Divider /> */}

									<Form.Group as={Row} >
										<Form.Label column sm="3" className="top3">
											Substrate
										</Form.Label>
										<Col sm="8">
											<Form.File id="exampleFormControlFile2" onChange={(e) => setFile2(e.target.files[0])} accept={[".cdx", ".cdxml"]} />


										</Col>

									</Form.Group>

									<Form.Group as={Row} >
										<Form.Label column sm="3" className="top3">
											Product
										</Form.Label>
										<Col sm="8">
											<Form.File id="exampleFormControlFile3" onChange={(e) => setFile3(e.target.files[0])} accept={[".cdx", ".cdxml"]} />


										</Col>

									</Form.Group>

									<div style={{ textAlign: "center" }}>
										<Button
											variant="outline-primary"
											onClick={!isLoading ? handleSubmit : null}

										>
											{isLoading ? 'PROCESSING' : 'SUBMIT'}
										</Button>
									</div>
									<div style={{ height: "25px" }} />

								</Form>
							</Card.Body>
						</Card>




					</div>

					<div style={{

						height: "50px"
					}}>
					</div>
				</Col>
				<Col>
				</Col>
			</Row>
		</div>

	);
};